import { UserDocumentType } from "@/shared/enums/UserDocumentType";

export class UserDocument {
  public id: string;
  public title: string;
  public fileType: string;

  constructor(data: any) {
    this.id = data.id;
    this.title = data.title;
    this.fileType = data.fileType;
  }

  public get documentType(): UserDocumentType {
    switch (this.fileType) {
      case "pdf":
        return UserDocumentType.Pdf;
      case "xlsx":
      case "xls":
      case "csv":
        return UserDocumentType.Excel;
      case "docx":
      case "doc":
        return UserDocumentType.Word;
      case "pptx":
      case "ppt":
        return UserDocumentType.PowerPoint;
      default:
        return UserDocumentType.Text;
    }
  }
}
